import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SmartDataTable from "../../components/SmartDataTable";

export default function DataSetActionsEdit() {
  const { datasetId } = useParams(); // route: /actions/bydataset/edit/:datasetId
  const navigate = useNavigate();
  const [printerGroups, setPrinterGroups] = React.useState([]);

  const columns = useMemo(
    () => [
      { label: "#", type: "count", value: "__count", width: "48px", align: "center" },
      { label: "Name", value: "name", search: "name", width: "200px" },
      { label: "Type", value: "type", search: "type", width: "120px" },
      { label: "Landing Page", value: "landingPageName", search: "landingPageName", width: "200px" },
      { label: "Card Design", value: "cardDesignName", search: "cardDesignName", width: "200px" },
      { label: "Printer Group", value: "printerGroupId.name", width: "180px" },
      {
        label: "Status",
        value: "status",
        width: "120px",
        type: "render",
        render: (r) => (r.status === "active" ? "Active" : "Inactive"),
      },
      {
        label: "Updated",
        value: "updatedAt",
        width: "160px",
        type: "render",
        render: (r) => (r.updatedAt ? new Date(r.updatedAt).toLocaleString() : ""),
      },
    ],
    []
  );

  const buttons = [
    { label: "Edit",   color: "blue",  action: "/actions/edit/{_id}" },      // (optional action editor page)
    { label: "Delete", color: "red",   action: "delete" },                    // wired via SmartDataTable delete
  ];

  React.useEffect(() => {
    fetch("/api/printmanager/groups/list") // update if different
      .then(res => res.json())
      .then(data => {
        setPrinterGroups(data.items || []);
      })
      .catch(err => console.error("Failed to fetch printer groups", err));
  }, []);

  return (
    <div>
    {/*  <div className="datatable-container compact" style={{ marginBottom: 8 }}>
        <div
          className="datatable-header-row"
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}
        >
          <h2 style={{ margin: 0 }}>Actions (Manage)</h2>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn" onClick={() => navigate("/actions")}>Return</button>
            <button className="btn-green" onClick={() => navigate(`/actions/add?datasetId=${encodeURIComponent(datasetId)}`)}>
              Add New Action
            </button>
          </div>
        </div>
      </div>  */}


      <h2>Actions (Manage)</h2>

      <div style={{ display: "flex", gap: 8 }}>

        <button className="btn-return" onClick={() => navigate("/actions")}>
          Return
        </button>

        <button className="btn-save" onClick={() => navigate(`/actions/add?datasetId=${encodeURIComponent(datasetId)}`)}  >
          Add New Action
        </button>

      </div>





      <SmartDataTable
        key={`edit-actions-${datasetId}`}
        config={{
          columns,
          queryName: "/actions/listByDataSet",
          pageSize: 20,
          fixedFilters: { datasetId },
          buttons,
          deletePathTemplate: "/actions/delete/{_id}",
          deleteMethod: "POST",
        }}
      />
    </div>
  );
}
